<p-dialog
  modal
  [(visible)]="isOpen"
  [style]="{ width: 'calc(100% - 4rem)', height: '100%' }"
  (onHide)="closeModal()"
>
  @if (!assistantBeingEdited) {
    <div class="compact-license-header">
      <div class="label">Company:</div>
      <div class="value">{{ companyName }}</div>
      <div class="label">License:</div>
      <div class="value">{{ license?.name ?? "" }}</div>
    </div>
  }

  @if (!assistantBeingEdited) {
    <div class="license-sections">
      <p-tabs [(value)]="selectedTab">
        <p-tablist>
          <p-tab value="general">General</p-tab>
          <p-tab value="model">Model</p-tab>
          <p-tab value="assistants">Assistants</p-tab>
          <p-tab value="remote_sources">Remote sources</p-tab>
          <p-tab value="branding">Branding</p-tab>
          <p-tab value="storage">Storage</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="general">
            <cognos-license-details-general
              [license]="license"
              [version]="version"
              (statusUpdated)="onStatusUpdated($event)"
            ></cognos-license-details-general>
          </p-tabpanel>
          <p-tabpanel value="model">
            <cognos-license-details-model
              [model]="settings?.model"
              [licenseId]="license?.id"
            ></cognos-license-details-model>
          </p-tabpanel>
          <p-tabpanel value="assistants">
            <cognos-license-details-assistants
              [licenseId]="license?.id"
              [assistantSettings]="settings"
              (openAssistantEdit)="onOpenAssistantEdit($event)"
            ></cognos-license-details-assistants>
          </p-tabpanel>
          <p-tabpanel value="remote_sources">
            <cognos-license-details-remote-sources
              [licenseId]="license?.id"
              [remoteSourcesList]="remoteSourcesList"
            ></cognos-license-details-remote-sources>
          </p-tabpanel>
          <p-tabpanel value="branding">
            <cognos-license-details-branding
              [brandingSettings]="settings?.branding"
              [licenseId]="license?.id"
              (settingsUpdated)="onBrandingSettingsUpdated($event)"
            ></cognos-license-details-branding>
          </p-tabpanel>
          <p-tabpanel value="storage">
            <cognos-license-details-storage
              [storageSettings]="settings?.storage"
              [licenseId]="license?.id"
            ></cognos-license-details-storage>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  }

  <!-- Full-screen (within dialog) Assistant Edit Overlay -->
  @if (assistantBeingEdited) {
    <div class="assistant-edit-overlay">
      <cognos-license-details-assistants
        [licenseId]="license?.id"
        [assistantSettings]="settings"
        [externalEditingAssistant]="assistantBeingEdited"
        (closeAssistantEdit)="closeAssistantEdit()"
      ></cognos-license-details-assistants>
    </div>
  }

  <ng-template #footer>
    <div class="footer-actions">
      <p-button
        label="Close"
        severity="secondary"
        raised
        (click)="closeModal()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
